import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { ExtractionEditionPayload, UpdatedExtractionData } from './extraction-edition.types';
import { transformIntoQueryParamString } from '@old/utils/service';

// deprecated service ref.: updateExtractionService_DEPRECATED
export async function updateExtractionService({ query: rawQuery, body }: ExtractionEditionPayload) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.put<UpdatedExtractionData>(ENDPOINT.SILOBAG_EXTRACTION, {
    query,
    body,
  });

  return {
    response,
    summary: data,
  };
}
